module.exports = __webpack_public_path__ + "img/adv_24_let_default_pic.bd4d8c28.png";